import { Avatar as ChakraAvatar, AvatarProps as ChakraAvatarProps } from '@chakra-ui/react';
import { getRandomNumber } from '@waitroom/utils';
import { memo, useMemo } from 'react';
import UpgradeBadge from '../../../session/components/Badge/Upgrade/UpgradeBadge';
import theme from '../../../theme';

const colorsLen = Object.keys(theme.colors.avatar).length - 1;
type Key = keyof typeof theme.colors.avatar;

export type AvatarProps = ChakraAvatarProps;

/**
 * Avatar component
 */
const Avatar = memo(({ name, bg, src, ...rest }: AvatarProps): React.ReactElement | null => {
  const background = useMemo(
    () =>
      bg ||
      theme.colors.avatar[
        (name ? name.charCodeAt(0) % colorsLen : getRandomNumber(0, colorsLen)) as Key
      ],
    [bg, name],
  );
  return <ChakraAvatar as="div" name={name?.trim()} bg={background} src={src} {...rest} />;
});

export type SubscriptionAvatarProps = AvatarProps & {
  premium?: boolean;
};
export const SubscriptionAvatar = ({ premium, ...rest }: SubscriptionAvatarProps) => (
  <Avatar {...rest}>{premium && <UpgradeBadge title="Premium" overlay />}</Avatar>
);

export default Avatar;
